import LiveClock from 'components/common/LiveClock';
import TemplateForm from 'components/template/TemplateForm';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { templatesSelector } from 'slices/templateSlice';
import { fetchTemplatesListPage } from 'slices/templateSlice';

const UpdateTemplate = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { templatesListPage, loader, error } = useSelector(templatesSelector);
    const { id } = useParams();

    useEffect(() => {
        dispatch(fetchTemplatesListPage());
    }, [dispatch]);

    if (!templatesListPage?.length) return <div>Loading...</div>;

    const item = templatesListPage?.find(t => t.id === Number(id));
    return (
        <div className='content'>
            <div className="row_main_head">
                <div className='d-flex align-items-center gap-2'>
                    <button className="main_heading back_button" onClick={() => navigate(-1)}>
                        <i className="fa-solid fa-arrow-left"></i> Back
                    </button>
                    <h2 className="main_heading">Update Accounts</h2>
                </div>
                {/* <LiveClock /> */}
            </div>

            {item ? <TemplateForm item={item} loader={loader} error={error} /> : <div>Item not found</div>}
        </div>
    );
};

export default UpdateTemplate;
